import type { ExplorationHighlight, ExplorationVolume } from '../../types/exploration';
import { reasonKeyForVolume } from './focusedReasonHelpers';
import {
  iconTypeForListingGroup,
  type ListingGroupIconTypeOptions,
} from './listingGroupIconType';
import { currentInnerPalette } from './sidebarPalettes';

/** Highlight payload for a sidebar group-bars row, aligned with bubble status/reason nodes. */
export function buildListingGroupHighlight(
  groupName: string,
  vols: ExplorationVolume[],
  opts: ListingGroupIconTypeOptions
): NonNullable<ExplorationHighlight> {
  const { view, location } = opts;

  if (location.focusedActivationKey && !location.reasonLabel && vols.length) {
    return { kind: 'status', key: reasonKeyForVolume(vols[0], location.focusedActivationKey) };
  }

  const iconType = iconTypeForListingGroup(groupName, opts);
  const allowsStatusHighlight = !iconType || iconType === 'volume';
  const palette = currentInnerPalette(view);
  const paletteMatch = vols.find((v) => palette.label(v[palette.field]) === groupName);
  if (paletteMatch && allowsStatusHighlight) {
    return { kind: 'status', key: paletteMatch[palette.field] };
  }

  // Same labels as computeTopLevelGroups under structural Unattached (supportStyleStatusLabel).
  const supportMatch = vols.find((v) => v.supportLabel === groupName);
  if (supportMatch && allowsStatusHighlight) {
    return { kind: 'status', key: supportMatch.supportStatus };
  }

  return {
    kind: 'group',
    name: groupName,
    type: iconType ?? undefined,
    ebsIds: vols.map((v) => v.ebsId).filter(Boolean),
  };
}
